import { render, staticRenderFns } from "./CatalogImportSummary.vue?vue&type=template&id=28b46bfb&scoped=true"
import script from "./CatalogImportSummary.vue?vue&type=script&lang=js"
export * from "./CatalogImportSummary.vue?vue&type=script&lang=js"
import style0 from "./CatalogImportSummary.vue?vue&type=style&index=0&id=28b46bfb&prod&scoped=true&lang=css"
import style1 from "./CatalogImportSummary.vue?vue&type=style&index=1&id=28b46bfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b46bfb",
  null
  
)

export default component.exports